var _process$env$NEXT_PUB;

globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { createContext, useContext } from 'react';
import { useFacebookPixel, useGoogleAnalytics, useSmartlook } from '../hooks';
import Script from 'next/script'; // import useSegment from '../hooks/use-segment';
// import useMixpanel from '../hooks/use-mixpanel';

import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import usePostHogProvider from '../hooks/use-posthog-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AnalyticsContext = /*#__PURE__*/createContext({
  isActive: false,
  trackEvent: function trackEvent(event, prop) {
    return null;
  },
  trackPHEvent: function trackPHEvent(event, prop) {
    return null;
  },
  startRecording: function startRecording() {
    return null;
  },
  fbTrackWorkerApplied: function fbTrackWorkerApplied() {
    return null;
  },
  fbTrackWorkerStartsApplication: function fbTrackWorkerStartsApplication() {
    return null;
  }
});
var isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
var clarityProjectId = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
export var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var children = _ref.children;

  // const { isActive, trackEvent } = useMixpanel();
  var _usePostHogProvider = usePostHogProvider(),
      trackPHEvent = _usePostHogProvider.trackEvent; // const { isActive, trackEvent } = useSegment();


  var _useSmartlook = useSmartlook(),
      startRecording = _useSmartlook.initialize;

  useGoogleAnalytics();

  var _useFacebookPixel = useFacebookPixel(),
      fbTrackWorkerApplied = _useFacebookPixel.trackWorkerApplied,
      fbTrackWorkerStartsApplication = _useFacebookPixel.trackWorkerStartsApplication;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isProd && /*#__PURE__*/_jsx(Script, {
      strategy: "lazyOnload",
      children: "\n          (function(c,l,a,r,i,t,y){\n            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n            t=l.createElement(r);t.async=1;t.src=\"https://www.clarity.ms/tag/\"+i;\n            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n          })(window, document, \"clarity\", \"script\", \"".concat(clarityProjectId, "\");\n        ")
    }), isProd && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Script, {
        strategy: "lazyOnload",
        async: true,
        src: "https://www.googletagmanager.com/gtag/js?id=AW-622219312"
      }), /*#__PURE__*/_jsx(Script, {
        strategy: "lazyOnload",
        children: "window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config','AW-622219312');"
      })]
    }), /*#__PURE__*/_jsx(PostHogProvider, {
      client: posthog,
      children: /*#__PURE__*/_jsx(AnalyticsContext.Provider, {
        value: {
          isActive: false,
          trackEvent: trackPHEvent,
          startRecording: startRecording,
          fbTrackWorkerApplied: fbTrackWorkerApplied,
          fbTrackWorkerStartsApplication: fbTrackWorkerStartsApplication,
          trackPHEvent: trackPHEvent
        },
        children: children
      })
    })]
  });
};
export var useAnalytics = function useAnalytics() {
  var context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within a AnalyticsProvider');
  }

  return context;
};